<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <router-view></router-view>
    </a-config-provider>
  </div>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import '../assets/css/common.less'
import utils from '../assets/js/utils';

export default {
  name: 'App',
  components: {},
  data () {
    return {
      locale: zh_CN,
    }
  },
  mounted () {
    let code = utils.getUrlSchoolCode(window.location.pathname)
    if (code) {
      localStorage.setItem("schoolCode", code);
    } else {
      localStorage.setItem("schoolCode", '');
    }
    if (process.env.NODE_ENV == 'production') {
      // 第二层判断打包后是测试环境还是正式环境 
      if (process.env.VUE_APP_FLAG === 'pro') {
        utils.loadStatistics();
      }
    }
  }
}
</script>

<style>
#app {
    /* font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
    width: 100%;
    min-height: 100%;
}
</style>
